import { useTranslation } from 'react-i18next';
import type { WarrantyHistory } from '@econtractor/types';
import { UserNameItem } from 'modules/user';
import DateTimeDisplay from 'components/dateTime/DateTimeDisplay';

interface WarrantyHistoryItemProps {
    row: WarrantyHistory;
}

const WarrantyHistoryItem = ({ row }: WarrantyHistoryItemProps) => {
    const { t } = useTranslation('Warranties');
    const changes = Object.entries(row.changes);

    return (
        <li className="task-history-timeline__item">
            <i className="task-history-timeline__dot bg-primary" aria-hidden="true" />
            <div className="task-history-timeline__body">
                <div className="d-flex align-items-start justify-content-between gap-3">
                    <span className="task-history-timeline__label">
                        {t(`events.${row.action}`)}
                    </span>
                    <DateTimeDisplay value={Number(row.createdAt)} />
                </div>
                <div className="task-history-timeline__author">
                    <UserNameItem
                        smallMode
                        user={{ userName: row.userName || '—', userPicture: row.userPicture || '' }}
                    />
                </div>
                {(row.fromObjectName || row.toObjectName || changes.length > 0) && (
                    <div className="task-history-timeline__reject">
                        {(row.fromObjectName || row.toObjectName) && (
                            <div className="task-history-timeline__reject-text">
                                {row.fromObjectName || '—'} → {row.toObjectName || '—'}
                            </div>
                        )}
                        {changes.map(([field, change]) => (
                            <div key={field} className="task-history-timeline__reject-text">
                                <span className="text-muted">{t(`fields.${field}`)}: </span>
                                {String(change.before ?? '—')} → {String(change.after ?? '—')}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </li>
    );
};

export default WarrantyHistoryItem;
